import axios from "axios";
import settings from "../utils/settings";
import futureaxios from "@fpos/future-axios";

futureaxios.options.throwOnError = true;

class cloudService {
    constructor(errorCallBack, oauthErrorCallBack) {
        this._faxios = new futureaxios(`${settings.cloudHost}/v1/`, errorCallBack);
        this._oafaxios = new futureaxios(`${settings.oauthAuthority}`, oauthErrorCallBack);

    }

    static create(errorCallBack, oauthErrorCallBack) {
        return (() => {
            axios.defaults.headers.common["Access-Control-Allow-Origin"] = settings.hostname;
            axios.defaults.headers.common["Access-Control-Allow-Headers"] = "Access-Control-*, Origin, X-Requested-With, Content-Type, Accept";
            axios.defaults.headers.common["Access-Control-Allow-Methods"] = "GET, POST, PUT, DELETE, OPTIONS, HEAD";
            return new cloudService(errorCallBack, oauthErrorCallBack);
        })();
    }
}

export default cloudService;